import React, { useState } from "react";

interface EmbedSnippetProps {
  agentId: string;
}

export function EmbedSnippet({ agentId }: EmbedSnippetProps) {
  const [copied, setCopied] = useState(false);

  const snippet = `<script
  src="https://cdn.sitechatagent.com/widget.js"
  data-agent-id="${agentId}"
  defer
></script>`;

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(snippet);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // fallback
      const ta = document.createElement("textarea");
      ta.value = snippet;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  }

  return (
    <div className="embed-section">
      <h2>Embed Script</h2>
      <p className="embed-desc">
        Paste this snippet into the <code>&lt;body&gt;</code> of your website to
        load the chat agent.
      </p>
      <pre className="embed-code">{snippet}</pre>
      <button className="btn btn-primary" onClick={handleCopy}>
        {copied ? "Copied!" : "Copy to clipboard"}
      </button>
    </div>
  );
}
